// extracted by mini-css-extract-plugin
export default {"mainHeading":"Welcome_mainHeading__wAuAv","content":"Welcome_content__D1Vcz"};